module.exports = __webpack_public_path__ + "static/media/cart.64c40f7a.svg";